import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

export const getRelatedDirectsCount = async (companyID, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const {
    data: { count },
  } = await axios.get(`/api/companies/${companyID}/directs/count?${queryString}`);

  return { count };
};

export const useRelatedDirectsCount = (companyID, queryParams) => {
  const { onlyExpired, includeInactive } = queryParams;
  return useQuery(['related-directs-count', companyID, onlyExpired, includeInactive], () =>
    getRelatedDirectsCount(companyID, { onlyExpired, includeInactive })
  );
};
